import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const Input = ({ 
  label, 
  error, 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  required = false,
  className = '',
  ...props 
}) => {
  const { t, isRTL } = useLanguage();

  return (
    <div className="space-y-1">
      {label && (
        <label className={`block text-sm font-medium text-gray-700 ${isRTL ? 'text-right' : 'text-left'}`}>
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`
          w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm 
          focus:outline-none focus:ring-2 focus:ring-minecraft-green focus:border-minecraft-green
          ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : ''}
          ${isRTL ? 'text-right' : 'text-left'}
          ${className}
        `}
        {...props}
      />
      {error && (
        <p className={`text-sm text-red-600 ${isRTL ? 'text-right' : 'text-left'}`}>
          {t(error)}
        </p>
      )}
    </div>
  );
};

export default Input;